export default {
      id: "ic_plus-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_plus-usage",
      toString: function () {
        return this.url;
      }
    }